import {GrowthBook} from "@growthbook/growthbook-react";

export const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-cYfhSJz4UrZ9JLC",
  enableDevMode: true,
  trackingCallback: (experiment, result) => {
  }
});